import React from 'react';
import { Typography } from 'fronton-react';

type PriceTextProps = {
	priceText: string;
	unitOfMeasurement: string;
};

export const PriceTextSmall = ({ priceText, unitOfMeasurement }: PriceTextProps) => (
	<Typography
		variant="s"
		size="body_short"
		style={{ letterSpacing: '0.3px' }}
		data-qa="small-price-text"
	>
		от{' '}
		<Typography variant="m" size="body_accent" style={{ letterSpacing: '0.05px' }}>
			{priceText}
		</Typography>{' '}
		&#8381;/{unitOfMeasurement}
	</Typography>
);

export const PriceTextLarge = ({ priceText, unitOfMeasurement }: PriceTextProps) => (
	<Typography
		variant="s"
		size="body_accent"
		style={{ letterSpacing: '0.3px', display: 'block', marginBottom: '16px' }}
		data-qa="large-price-text"
		data-analyticsName="productPriceLink"
	>
		от{' '}
		<Typography
			variant="l"
			size="subtitle"
			style={{ letterSpacing: '0.05px', fontWeight: 700, fontSize: '22px' }}
		>
			{priceText}
		</Typography>{' '}
		&#8381;/{unitOfMeasurement}
	</Typography>
);
